import { apiClient, SIGNUP } from '../../../shared/api';

export const signup = async (userData) => {
  const { businessName, email, firstName, lastName, password, paymentMethodId, planId } =
    userData;

  const requestBody = {
    user: {
      business_name: businessName,
      email,
      first_name: firstName,
      last_name: lastName,
      password,
      password_confirmation: password,
      payment_method_id: paymentMethodId,
      plan_id: planId,
    },
  };

  return apiClient.post(SIGNUP, requestBody);
};
